import React from 'react'
export default function AlertIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M15.216 13.529 8.882 1.654a1 1 0 0 0-1.765 0L.784 13.529A1 1 0 0 0 1.667 15h12.667a1 1 0 0 0 .882-1.471zM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-3H7V6h2v4z"/></g></svg>)
}
